import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white" }
const _hoisted_2 = { class: "d-flex flex-wrap justify-content-between p-2" }
const _hoisted_3 = { class: "p-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LeftSideBar = _resolveComponent("LeftSideBar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!this.hiddenSideBar)
      ? (_openBlock(), _createBlock(_component_LeftSideBar, {
          key: 0,
          modelValue: this.sideBarMenus,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.sideBarMenus) = $event)),
          "collapsed-menu-default": true,
          class: "position-absolute",
          onClosed: _cache[1] || (_cache[1] = () => {
          this.hiddenSideBar = true
        })
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Button, {
          icon: "pi pi-bars",
          class: "rounded",
          severity: "secondary",
          onClick: _cache[2] || (_cache[2] = () => {
              this.hiddenSideBar = false
            })
        }),
        _createElementVNode("div", null, [
          _createVNode(_component_router_link, { to: {name: 'bots_list'} }, {
            default: _withCtx(() => [
              _createVNode(_component_Button, {
                label: "Личный кабинет",
                icon: "pi pi-home",
                class: "rounded"
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_view)
      ])
    ])
  ]))
}